<template>
    <v-container flex grid-list-lg>
        <template v-if="!smartLock">
            <smart-lock-message></smart-lock-message>
        </template>
        <v-layout row wrap v-else>
            <v-flex xs12>
                <v-toolbar color="#eee" class="elevation-0 secondary--text">
                  <v-toolbar-title>Veículos</v-toolbar-title>
                  <v-spacer></v-spacer>
                  <v-slide-x-transition>
                    <v-layout justify-end v-show="searching">
                      <v-flex xs1>
                        <v-tooltip bottom>
                          <v-btn
                            icon
                            color="info"
                            @click="carregarVeiculos(true)"
                            slot="activator"
                          >
                            <v-icon>search</v-icon>
                          </v-btn>
                          <span>Pesquisar</span>
                        </v-tooltip>
                      </v-flex>
                      <v-flex xs3>
                        <v-select
                          outline
                          hide-details
                          single-line
                          placeholder="Filtrar por"
                          :items="filtros"
                          item-value="value"
                          item-text="text"
                          v-model="filtro"
                        ></v-select>
                      </v-flex>
                      <v-flex xs4>
                        <v-text-field
                          outline
                          hide-details
                          single-line
                          :readonly="!filtro"
                          v-model="campoPesquisa"
                        ></v-text-field>
                    </v-flex>
                    </v-layout>
                  </v-slide-x-transition>
                  <v-btn icon color="info" @click="searching = !searching">
                    <v-icon v-if="!searching">search</v-icon>
                    <v-icon v-else>close</v-icon>
                  </v-btn>
                  <opcionais-de-veiculos/>
                  <tipos-de-veiculos/>
                  <v-tooltip bottom>
                    <v-btn icon color="info" slot="activator" @click="dialogCadEmpresa = true">
                      <v-icon>add</v-icon>
                    </v-btn>
                    <span>Cadastrar Nova Empresa</span>
                  </v-tooltip>
                </v-toolbar>
            </v-flex>
            <v-flex xs12>
                <v-data-table
                    :headers="veiculosHeaders"
                    :items="veiculos"
                    :loading="loading"
                    :pagination.sync="pagination"
                    :total-items="totalItems"
                    hide-actions
                >
                <v-progress-linear slot="progress" color="blue" indeterminate></v-progress-linear>
                <template slot="headerCell" slot-scope="{ header }">
                    <span class="font-weight-light" v-text="header.text" />
                </template>
                <template slot="items" slot-scope="props">
                    <td>{{ (props.item.identificacao || ' ').toUpperCase() }}</td>
                    <td class="text-xs-left">
                        {{ props.item.usuario && props.item.usuario.pessoa ?
                            `${props.item.usuario.pessoa.nome} ${props.item.usuario.pessoa.sobrenome}` : '' }}
                    </td>
                    <td class="text-xs-left">{{ props.item.empresa ? props.item.empresa.nome_fantasia : '' }}</td>
                    <td class="text-xs-left">{{ props.item.motorista ? props.item.motorista.nome_email : '' }}</td>
                    <td class="text-xs-left">
                      <v-btn
                        small
                        round
                        :color="projetoVeiculo(props.item.projeto).color"
                      >
                      {{ projetoVeiculo(props.item.projeto).text }}
                    </v-btn>
                    </td>
                    <td class="text-xs-left">
                        <v-btn
                          flat
                          icon
                          v-if="props.item.ativo"
                          color="green lighten-2"
                          @click="
                            dialogExcluir = true,
                            veiculoSelecionado = props.item
                          ">
                            <v-icon>check_circle</v-icon>ATIVA
                        </v-btn>
                        <v-btn
                          flat
                          icon
                          v-else
                          color="error"
                          @click="
                            dialogExcluir = true,
                            veiculoSelecionado = props.item
                          ">
                            <v-icon>cancel</v-icon>INATIVA
                        </v-btn>
                    </td>
                    <td>
                        <v-tooltip lazy bottom>
                          <v-btn
                            slot="activator"
                            flat
                            icon
                            color="info"
                            @click="dialogEditar = true, veiculoSelecionado = props.item"
                          >
                              <v-icon>edit</v-icon>
                          </v-btn> Editar dados do veículo
                        </v-tooltip>
                        <v-tooltip lazy bottom>
                          <v-btn
                            slot="activator"
                            flat
                            icon
                            color="primary"
                            @click="dialogVisializar = true, veiculoSelecionado = props.item"
                          >
                              <v-icon>remove_red_eye</v-icon>
                          </v-btn> Visualizar dados do veículo
                        </v-tooltip>
                    </td>
                </template>
                </v-data-table>
                <div class="text-xs-center pt-2">
                    <v-pagination color="info" circle v-model="pagination.page" :length="pages"></v-pagination>
                </div>
            </v-flex>
        </v-layout>
        <v-dialog
            v-model="dialogVisializar"
            v-if="dialogVisializar"
            width="55em"
            scrollable
        >
            <visualizar-veiculo
                @fechar="dialogVisializar = false, veiculoSelecionado = undefined"
                :veiculo="veiculoSelecionado"
            />
        </v-dialog>
        <v-dialog
            v-model="dialogEditar"
            v-if="dialogEditar"
            width="55em"
            scrollable
        >
            <editar-veiculo
                @fechar="dialogEditar = false, veiculoSelecionado = undefined"
                :veiculo="veiculoSelecionado"
                @success="showSuccess"
                @error="showError"
                @carregar="carregarVeiculos(false)"
            />
        </v-dialog>
        <v-dialog v-model="dialogExcluir" v-if="dialogExcluir" width="25em">
          <v-card v-if="veiculoSelecionado">
            <v-card-title class="justify-center" style="font-size: 1.4em">
              Deseja {{veiculoSelecionado.ativo ? 'desativar' : 'ativar'}} esse veículo
            </v-card-title>
            <v-card-actions class="justify-space-around">
              <v-btn
                round
                small
                class="mb-2"
                @click="
                  dialogExcluir = false,
                  veiculoSelecionado = undefined"
                >
                  Não
                </v-btn>
              <v-btn round small class="mb-2" color="error" @click="ativaOuDesativarVeiculo">Sim</v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
        <v-snackbar
          v-model="snackbar.active"
          :color="snackbar.color"
          :multi-line="snackbar.multiLine"
          :timeout="snackbar.timeout"
          :vertical="snackbar.vertical"
        >
          {{ snackbar.text }}
          <v-btn
            flat
            @click="snackbar.active = false"
          >
            Fechar
          </v-btn>
      </v-snackbar>
    </v-container>
</template>

<script>

import SmartLockMessage from '@/components/SmartLockMessage'
import VisualizarVeiculo from '@/components/dialogs/VisualizarVeiculo'
import EditarVeiculo from '@/components/dialogs/EditarVeiculo'
import OpcionaisDeVeiculos from '@/components/dialogs/OpcionaisDeVeiculos'
import TiposDeVeiculos from '@/components/dialogs/TiposDeVeiculos'

export default {
  components: { SmartLockMessage, VisualizarVeiculo, EditarVeiculo, OpcionaisDeVeiculos, TiposDeVeiculos },
  data () {
    return {
      veiculos: [],
      totalItems: 0,
      veiculoSelecionado: undefined,
      dialogVisializar: false,
      dialogEditar: false,
      dialogExcluir: false,
      snackbar: {
        active: false,
        color: '',
        multiLine: true,
        timeout: 4000,
        vertical: true,
        text: ''
      },
      pagination: {
        rowsPerPage: 5,
        page: 1
      },
      veiculosHeaders: [
      {
        text: 'Placa',
        align: 'left',
        sortable: false,
        value: 'identificacao'
      },
      { text: 'Usuário', sortable: false },
      { text: 'Empresa', sortable: false, value: 'empresa.nome_fantasia' },
      { text: 'Funcionário', sortable: false, value: 'motorista.nome_email' },
      { text: 'Aplicativo', sortable: false, value: 'projeto' },
      { text: 'Status', sortable: false, value: 'ativo' },
      {
        sortable: false,
        align: 'right'
      },
      {
        sortable: false,
        align: 'right'
      }
      ],
      searching: false,
      filtros: [
        {
          value: 'identificacao',
          text: 'Placa'
        },
        {
          value: 'empresa',
          text: 'CNPJ da empresa'
        },
        {
          value: 'nome_fantasia',
          text: 'Nome Fantasia da empresa'
        },
        {
          value: 'usuario',
          text: 'CPF do Usuário'
        },
        {
          value: 'email',
          text: 'E-mail do Usuário'
        },
        {
          value: 'motorista',
          text: 'CPF do Funcionário'
        }
      ],
      campoPesquisa: '',
      filtro: ''
    }
  },
  computed: {
    smartLock () {
      return this.$store.getters.smartLock
    },
    loading () {
      return this.$store.getters.loading
    },
    headers () {
      return this.$store.getters.headers
    },
    pages () {
      if (this.pagination.rowsPerPage == null || this.totalItems == null) {
        return 0
      }

      return Math.ceil(this.totalItems / this.pagination.rowsPerPage)
    }
  },
  methods: {
    projetoVeiculo (projeto) {
      switch (projeto) {
        case 'apetrus':
          return { color: 'primary', text: 'Apetrus' }
        case 'conecta_revendas':
          return { color: 'success', text: 'Conecta Revendas' }
        case 'conecta_frota':
          return { color: 'secondary', text: 'Conecta Frota' }
        default:
          return { color: 'info', text: 'White Label' }
      }
    },
    carregarVeiculos (zerarPaginacao) {
        let data = {
            page: zerarPaginacao ? 1 : this.pagination.page
        }
        if (this.campoPesquisa) {
            switch (this.filtro) {
                case 'identificacao':
                  data['identificacao__icontains'] = this.campoPesquisa
                  break
                case 'empresa':
                  data['empresa__cnpj__icontains'] = this.campoPesquisa
                  break
                case 'nome_fantasia':
                    data['empresa__nome_fantasia__icontains'] = this.campoPesquisa
                    break
                case 'usuario':
                    data['usuario__pessoa__cpf__icontains'] = this.campoPesquisa
                    break
                case 'email':
                    data['usuario__pessoa__email__icontains'] = this.campoPesquisa
                    break
                case 'motorista':
                    data['motorista__cpf__icontains'] = this.campoPesquisa
                    break
                default:
                    return
            }
        } else {
          return
        }
        this.$store.dispatch('pegarVeiculos', data).then(json => {
            this.veiculos = json.results
            this.totalItems = json.count
        })
    },
    ativaOuDesativarVeiculo () {
        this.$store.dispatch('editarVeiculo', {
          id_veiculo: this.veiculoSelecionado.id_veiculo,
          ativo: !this.veiculoSelecionado.ativo,
          projeto: this.veiculoSelecionado.projeto
        }).then(() => {
            this.showSuccess('Veículo alterado com sucesso.')
            this.carregarVeiculos()
            this.veiculoSelecionado = undefined
            this.dialogExcluir = false
        }).catch(() => {
          this.showError('Não foi possível alterar o veículo')
        })
    },
    showSuccess (text) {
      this.snackbar.color = 'primary'
      this.snackbar.text = text
      this.snackbar.active = true
    },
    showError (text) {
      this.snackbar.color = 'error'
      this.snackbar.text = text
      this.snackbar.active = true
    }
  },
  watch: {
    'pagination.page' (val) {
      if (val) {
        this.carregarVeiculos()
      }
    },
    searching (val) {
      if (!val) {
        this.filtro = ''
        this.campoPesquisa = ''
      }
    }
  }
}
</script>
